import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@talentmesh/ui/components/dialog';
import { Separator } from '@talentmesh/ui/components/separator';
import { useMemo } from 'react';
import { useProfileContactInfo } from '../../api/useProfileContactInfo';
import { useAiSearchProfilePopoutContext } from './AiSearchProfilePopoutContext';
import ProfileActions from './Profile/ProfileActions';
import ProfileExtra from './Profile/ProfileExtra/ProfileExtra';
import ProfileSummary from './Profile/ProfileSummary/ProfileSummary';
import ProfileTimeline from './Profile/ProfileTimeline/ProfileTimeline';
import UIStrings from '@/Utils/UIStrings';

const AiSearchProfileDialog = () => {
    const { open, closeProfilePopout, selectedProfile } = useAiSearchProfilePopoutContext();
    const { data } = useProfileContactInfo(selectedProfile?.url);
    const hasTimeline = useMemo(
        () =>
            !!selectedProfile?.experience?.length ||
            !!selectedProfile?.education?.length ||
            !!selectedProfile?.about?.trim(),
        [selectedProfile],
    );
    const hasExtra = useMemo(
        () =>
            !!data?.personalEmailAvailable ||
            !!data?.workEmailAvailable ||
            !!selectedProfile?.searchCriteriaScores?.length,
        [data, selectedProfile],
    );

    return (
        <Dialog
            open={open}
            onOpenChange={(nextOpen) => {
                if (!nextOpen) {
                    closeProfilePopout();
                }
            }}
        >
            <DialogContent
                data-cy="aiSearchProfilePopout"
                showCloseButton={false}
                className="bg-card pointer-events-auto flex max-h-11/12 w-full max-w-10/12 min-w-10/12 flex-col gap-0 rounded-xl border p-0 shadow-lg"
            >
                <DialogHeader className="shrink-0 space-y-0 px-6 py-4 text-left">
                    <DialogTitle className="sr-only">{UIStrings.ProfileInformation}</DialogTitle>
                    <DialogDescription className="sr-only">
                        {UIStrings.ProfileDescription}: {selectedProfile?.name}
                    </DialogDescription>
                    <ProfileActions />
                    <Separator className="my-2.5" />
                </DialogHeader>
                <div className="min-h-0 flex-1 overflow-y-auto px-6 pb-6">
                    <div className="flex flex-col gap-6">
                        <ProfileSummary />
                        {(hasTimeline || hasExtra) && (
                            <div className="flex flex-row items-stretch gap-6">
                                {hasTimeline && (
                                    <div className="min-w-0 flex-1">
                                        <ProfileTimeline />
                                    </div>
                                )}
                                {hasTimeline && hasExtra && (
                                    <Separator orientation="vertical" className="hidden h-auto min-h-32 md:block" />
                                )}
                                {hasExtra && (
                                    <div className="min-w-0 flex-1">
                                        <ProfileExtra />
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default AiSearchProfileDialog;
